document.addEventListener('DOMContentLoaded', () => {
  (function () {
    const state = {
      role: null,
      email: null,
      attemptId: null,
      resumeToken: null,
      answers: {},
      backendUrl: 'https://careers.pharmboutique.com'
    };

    const heroBtn = document.querySelector('[data-action="start"]');
    const rolesBlock = document.querySelector('.careers__roles');
    const stepBlock = document.getElementById('careers-step');

    if (!heroBtn || !rolesBlock || !stepBlock) return;

    // START FLOW
    heroBtn.addEventListener('click', () => {
      rolesBlock.hidden = false;
      heroBtn.scrollIntoView({ behavior: 'smooth' });
    });

    document.querySelectorAll('.role-card').forEach(btn => {
      btn.addEventListener('click', () => {
        state.role = btn.dataset.role.toLowerCase(); // developer / marketer / designer
        renderEmailStep();
      });
    });

    // EMAIL STEP
    function renderEmailStep() {
      stepBlock.innerHTML = `
        <h2>Start your application</h2>
        <input type="email" id="careers-email" placeholder="Email" required>
        <label class="checkbox">
          <input type="checkbox" id="careers-consent">
          I agree to the Privacy Policy
        </label>
        <button class="careers-btn" id="careers-start">Start test</button>
        <p class="error" hidden></p>
      `;
      document.getElementById('careers-start').addEventListener('click', startTest);
    }

    // START TEST
    async function startTest() {
      const email = document.getElementById('careers-email').value.trim();
      const consent = document.getElementById('careers-consent').checked;
      const error = stepBlock.querySelector('.error');
      error.hidden = true;

      if (!email || !consent) {
        error.textContent = 'Email and consent are required.';
        error.hidden = false;
        return;
      }

      state.email = email;

      try {
        const res = await fetch(`${state.backendUrl}/api/careers/start`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email, role: state.role, consent: true })
        });

        if (!res.ok) throw new Error();

        const data = await res.json();
        state.attemptId = data.attemptId;
        renderQuestions(data.questions || []);
      } catch {
        error.textContent = 'Server error. Try later.';
        error.hidden = false;
      }
    }

    // RENDER QUESTIONS (GENERAL + PROFILE)
    function renderQuestions(questions) {
      let html = `<h2>Short test</h2>`;

      questions.forEach(q => {
        html += `<div class="question" data-id="${q.id}" data-required="${q.required !== false}">
          <p>${q.text}${q.required !== false ? ' *' : ''}</p>`;

        if (q.type === 'choice') {
          q.options.forEach(opt => {
            html += `<label>
              <input type="radio" name="${q.id}" value="${opt}">
              ${opt}
            </label>`;
          });
        } else {
          html += `<textarea name="${q.id}" placeholder="Your answer…"></textarea>`;
        }

        html += `</div>`;
      });

      html += `<button class="careers-btn" id="submit-test">Submit Test</button>
               <p class="error" hidden></p>`;

      stepBlock.innerHTML = html;
      document.getElementById('submit-test').addEventListener('click', submitTest);
    }

    // SUBMIT TEST
    async function submitTest() {
      const error = stepBlock.querySelector('.error');
      error.hidden = true;

      const answers = {};
      let valid = true;

      stepBlock.querySelectorAll('.question').forEach(qEl => {
        const id = qEl.dataset.id;
        const required = qEl.dataset.required === 'true';
        const input = qEl.querySelector('input:checked') || qEl.querySelector('textarea');

        if (!input || !input.value.trim()) {
          if (required) valid = false;
          return;
        }

        answers[id] = input.value.trim();
      });

      if (!valid) {
        error.textContent = 'Please answer all required questions.';
        error.hidden = false;
        return;
      }

      state.answers = answers;

      try {
        const res = await fetch(`${state.backendUrl}/api/careers/submit`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attemptId: state.attemptId, answers })
        });

        if (!res.ok) throw new Error();

        const data = await res.json();
        if (data.status !== 'PASS') {
          stepBlock.innerHTML = `<h2>Thank you</h2><p>You can retry later.</p>`;
          return;
        }

        state.resumeToken = data.resume_token;
        renderResumeForm();
      } catch {
        error.textContent = 'Server error. Try later.';
        error.hidden = false;
      }
    }

    // RENDER RESUME FORM
    function renderResumeForm() {
      stepBlock.innerHTML = `
        <h2>Submit your Resume</h2>
        <form id="resume-form">
          <input type="text" name="full_name" placeholder="Full Name" required>
          <input type="email" name="email" value="${state.email}" readonly>
          <input type="text" name="country" placeholder="Country" required>
          <input type="text" name="timezone" placeholder="Timezone" required>
          <input type="url" name="linkedin" placeholder="LinkedIn URL">
          <input type="url" name="portfolio" placeholder="Portfolio URL">
          <input type="file" name="resume" accept=".pdf,.doc,.docx" required>
          <button class="careers-btn" id="resume-submit" disabled>Submit Resume</button>
        </form>
        <p class="error" hidden></p>
      `;

      const form = document.getElementById('resume-form');
      const fileInput = form.querySelector('input[type="file"]');
      const submitBtn = document.getElementById('resume-submit');

      fileInput.addEventListener('change', () => {
        submitBtn.disabled = !fileInput.files.length;
      });

      form.addEventListener('submit', submitResume);
    }

    // SUBMIT RESUME
    async function submitResume(e) {
      e.preventDefault();
      const error = stepBlock.querySelector('.error');
      const submitBtn = document.getElementById('resume-submit');
      error.hidden = true;

      if (!state.resumeToken) {
        error.textContent = 'Resume token missing.';
        error.hidden = false;
        return;
      }

      submitBtn.disabled = true;
      const formData = new FormData(e.target);

      // додаємо відповіді на тест
      Object.entries(state.answers || {}).forEach(([k, v]) => formData.append(k, v));

      try {
        const res = await fetch(`${state.backendUrl}/api/careers/resume`, {
          method: 'POST',
          headers: { 'x-resume-token': state.resumeToken },
          body: formData
        });

        if (!res.ok) throw new Error();

        stepBlock.innerHTML = `
          <h2>✅ Application received</h2>
          <p>Thank you. We’ll be in touch.</p>
        `;
      } catch {
        submitBtn.disabled = false;
        error.textContent = 'Upload failed. Try again.';
        error.hidden = false;
      }
    }

  })();
});
